import { Button, Dialog, Grid, makeStyles } from '@material-ui/core';
import HomePageCard from '../../home/card';
import en from '../../../lang/en-us';
import { useEffect, useState } from 'react';
import { getPortfolio } from '../../../redux-store/actions/portfolio';
import { connect, useDispatch, useSelector } from 'react-redux';
import { RootStateType } from '../../../redux-store/reducers';
import { CombinedState } from 'redux';
import { RouteComponentProps } from 'react-router';
import { getNotifications } from '../../../redux-store/actions/login';
import {
    AuthState,
    CLEAR_POPUP_STATUS,
    NotificationPayload,
    REDIRECT_ACTION,
} from '../../../redux-store/types/login';
import { IsAllow } from '../../../redux-store/types/portfolio';
import { isMobileDevice } from '../../../utils/constants';

const { dashboard, common } = en;

const useStyles = makeStyles((theme) => ({
    mitraCard: {
        [theme.breakpoints.up(768)]: {
            display: 'none',
        },
    },
}));

interface HomeProps extends RouteComponentProps {
    getNotifications: (body: NotificationPayload) => Promise<any>;
    displayName: string;
    unmatched: string[];
    mobile: string;
    email: string;
    pan: string;
    pekrn: string;
    reqId: string;
    redirectPath: string;
    enablePin: boolean;
    updateFirstTimeSettings: (body: Partial<AuthState>) => void;
    screenFlow: 'PIN_SET' | 'FINGER_PRINT' | 'HOME';
    enableTwoFactorAuth: boolean;
    showPopUp: IsAllow;
    message: string;
}

export function FundInfoDialog({
    fundInfoShow = false,
    setFundInfoShow,
}: {
    fundInfoShow: boolean;
    setFundInfoShow: (value: boolean) => void;
}) {
    return (
        <Dialog maxWidth={'md'} open={fundInfoShow} aria-labelledby="note-modals">
            <div style={{ maxWidth: 700 }} className="note-modals">
                <h3>{dashboard.noteModals.nctModal.heading}</h3>
                <div style={{ textAlign: 'left' }}>
                    <p style={{ marginBottom: 15 }}>{common.fundInfoModal.info1}</p>
                    <p style={{ marginBottom: 15 }}>{common.fundInfoModal.info2}</p>
                    <p style={{ marginBottom: 35 }}>{common.fundInfoModal.info3}</p>
                </div>
                <div className="note-modals-btns">
                    <Button className="customBtn" onClick={() => setFundInfoShow(!fundInfoShow)}>
                        {'OK'}
                    </Button>
                </div>
            </div>
        </Dialog>
    );
}

export function Info({
    info = '',
    icon = 'info2.svg',
    onClick,
}: {
    info?: string;
    icon?: string;
    onClick?: React.MouseEventHandler<HTMLImageElement>;
}) {
    return (
        // <CustomToolTip arrow title={info}>
        <img
            onClick={onClick}
            style={{
                width: 22,
                cursor: 'pointer',
                margin: 0,
                marginLeft: 10,
                position: 'relative',
            }}
            src={`/images/${icon}`}
            alt="info"
        />
        // </CustomToolTip>
    );
}

const isMessageHTML = (message: string) => {
    const tagsToFind = ['<div>', '<p>', '<h1>'];
    for (let i = 0; i < tagsToFind.length; ++i) {
        if (message.search(tagsToFind[i]) >= 0) {
            return true;
        }
    }
    return false;
};

function Home({ displayName = '', unmatched = [], ...props }: HomeProps) {
    const classes = useStyles();
    const [show, setShow] = useState<boolean>(false);
    const [showAmcModal, setShowAmcModal] = useState(
        props.showPopUp?.toUpperCase() === IsAllow.YES,
    );
    const [fundInfoShow, setFundInfoShow] = useState<boolean>(false);
    const dispatch = useDispatch();
    const { ftTransactionFlag } = useSelector(({ authReducer }: RootStateType) => ({
        ftTransactionFlag: authReducer?.ftTransactions,
    }));
    const shouldParseMessageAsHTML = isMessageHTML(props.message);
    useEffect(() => {
        async function callApi() {
            try {
                const { mobile, email, pan, reqId, pekrn } = props;
                await props.getNotifications({ mobile, email, pan, pekrn, reqId });
            } catch (err: any) {
                alert(err.message);
            }
        }
        callApi();
        if (!!props.redirectPath) {
            dispatch({ type: REDIRECT_ACTION, body: { redirectPath: null } });
            props.history.replace(props.redirectPath);
        }
    }, []);

    const _goToLink = (url: string) => () => {
        window.open(url, 'blank');
    };

    const modalShow = (e: any) => {
        e.stopPropagation();
        setFundInfoShow(true);
    };

    return (
        <div>
            <HomePageCard className="db-banner db-welcome">
                <>
                    <img
                        className="db-banner-character"
                        src="/images/db-home-character.png"
                        alt="icon"
                    />
                    <h3>
                        <b>{en.dashboard.dashboardHome.welcome.welcome}</b>{' '}
                        {displayName[0] + displayName.slice(1)}
                    </h3>
                    <p>{en.dashboard.dashboardHome.welcome.info}</p>
                    {!!unmatched.length && (
                        <div className="db-welcome-bottom">
                            <div className="db-welcome-notification">
                                <img src="/images/unregistered-folio.svg" alt="icon" />
                                <a
                                    onClick={() =>
                                        props.history.push('/portal/unregistered-folios')
                                    }
                                >
                                    {/* {en.dashboard.dashboardHome.welcome.notificationinfoLeft}
                                    {unmatched.length}
                                    {en.dashboard.dashboardHome.welcome.notificationinfoRight} */}
                                    {en.dashboard.dashboardHome.welcome.unregisteredFolios}
                                    <img src="/images/right-arrow-white.svg" alt="icon" />
                                </a>
                            </div>
                            {/* <div className="db-welcome-date">
                                <h4>10:10</h4>
                                <h5>
                                Tuesday <span>1 June, 2021</span>
                                </h5>
                            </div> */}
                        </div>
                    )}
                </>
            </HomePageCard>
            <div
                className={`db-cards ${classes.mitraCard}`}
                style={{
                    background: 'linear-gradient(110.77deg, #FF8A6C 0%, #FF729F 100%)',
                    position: 'relative',
                    padding: '16px',
                    borderRadius: '8px',
                }}
            >
                {/* Content wrapper */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    {/* Icon with NEW badge overlay */}
                    <div style={{ position: 'relative', width: '40px', height: '40px' }}>
                        {/* Mitra Icon - stacked documents with frame */}
                        <svg
                            width="40"
                            height="40"
                            viewBox="0 0 40 40"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M36.25 2.5H30C29.3088 2.5 28.75 3.06 28.75 3.75C28.75 4.44 29.3088 5 30 5H35V10C35 10.69 35.5588 11.25 36.25 11.25C36.9412 11.25 37.5 10.69 37.5 10V3.75C37.5 3.06 36.9412 2.5 36.25 2.5Z"
                                fill="#361667"
                            />
                            <path
                                d="M3.75 11.25C4.44 11.25 5 10.69 5 10V5H10C10.69 5 11.25 4.44 11.25 3.75C11.25 3.06 10.69 2.5 10 2.5H3.75C3.06 2.5 2.5 3.06 2.5 3.75V10C2.5 10.69 3.06 11.25 3.75 11.25Z"
                                fill="#361667"
                            />
                            <path
                                d="M10 35H5V30C5 29.3088 4.44 28.75 3.75 28.75C3.06 28.75 2.5 29.3088 2.5 30V36.25C2.5 36.9412 3.06 37.5 3.75 37.5H10C10.69 37.5 11.25 36.9412 11.25 36.25C11.25 35.5588 10.69 35 10 35Z"
                                fill="#361667"
                            />
                            <path
                                d="M36.25 28.75C35.5588 28.75 35 29.3088 35 30V35H30C29.3088 35 28.75 35.5588 28.75 36.25C28.75 36.9412 29.3088 37.5 30 37.5H36.25C36.9412 37.5 37.5 36.9412 37.5 36.25V30C37.5 29.3088 36.9412 28.75 36.25 28.75Z"
                                fill="#361667"
                            />
                            <path
                                d="M31.25 18.75V10C31.25 9.31 30.6912 8.75 30 8.75H10C9.31 8.75 8.75 9.31 8.75 10V18.75H31.25Z"
                                fill="white"
                                fill-opacity="0.5"
                            />
                            <path
                                d="M8.75 21.25V30C8.75 30.6912 9.31 31.25 10 31.25H30C30.6912 31.25 31.25 30.6912 31.25 30V21.25H8.75Z"
                                fill="white"
                                fill-opacity="0.5"
                            />
                            <path
                                d="M36.25 18.75H31.25H8.75H3.75C3.06 18.75 2.5 19.31 2.5 20C2.5 20.69 3.06 21.25 3.75 21.25H8.75H31.25H36.25C36.9412 21.25 37.5 20.69 37.5 20C37.5 19.31 36.9412 18.75 36.25 18.75Z"
                                fill="#361466"
                            />
                        </svg>
                        {/* NEW Badge - positioned overlapping icon */}
                        <div
                            style={{
                                position: 'absolute',
                                top: '-4px',
                                left: '19px',
                                width: '47px',
                                height: '18px',
                            }}
                        >
                            <img
                                alt=""
                                src="/images/new-badge.svg"
                                style={{
                                    display: 'block',
                                    width: '47px',
                                    height: '18px',
                                    maxWidth: 'none',
                                }}
                            />
                            <p
                                style={{
                                    position: 'absolute',
                                    fontFamily: "'Montserrat-SemiBold', sans-serif",
                                    fontWeight: '600',
                                    fontSize: '12px',
                                    color: '#fff',
                                    left: '8px',
                                    top: '1px',
                                    margin: 0,
                                    lineHeight: 'normal',
                                }}
                            >
                                NEW
                            </p>
                        </div>
                    </div>

                    {/* Title and Description */}
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                        <p
                            style={{
                                fontFamily: 'Montserrat-Bold',
                                fontWeight: 'bold',
                                color: '#fff',
                                margin: 0,
                            }}
                        >
                            <span style={{ fontSize: '16px' }}>Mitra — </span>
                            <span style={{ fontSize: '14px' }}>Trace Your MF Investments</span>
                        </p>
                        <p
                            style={{
                                fontFamily: 'Montserrat-Medium',
                                fontWeight: '500',
                                fontSize: '12px',
                                color: 'rgba(255,255,255,0.8)',
                                lineHeight: '1.5',
                                margin: 0,
                            }}
                        >
                            {en.dashboard.dashboardHome.mitra.description}
                        </p>
                    </div>
                </div>

                {/* Start Tracing Button */}

                <a
                    onClick={() =>
                        window.open(
                            `https://app.mfcentral.com/links/mitra`,
                            isMobileDevice() ? '_system' : '_blank',
                        )
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mobile_mode"
                    style={{ textDecoration: 'none', display: 'block' }}
                >
                    <div
                        style={{
                            background: 'rgba(0,0,0,0.16)',
                            borderRadius: '92px',
                            padding: '6px 12px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            width: '136px',
                            marginTop: '10px',
                        }}
                    >
                        <span
                            style={{
                                fontFamily: 'Montserrat-SemiBold',
                                fontWeight: '600',
                                fontSize: '12px',
                                color: '#fff',
                            }}
                        >
                            {en.dashboard.dashboardHome.mitra.buttonText}
                        </span>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                            <path
                                d="M9 18l6-6-6-6"
                                stroke="#fff"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </div>
                </a>
            </div>
            <Grid container spacing={0} xs={12} className="db-grid-boxes db-quick-link-boxes">
                <Grid item xs={12} sm={4}>
                    <a onClick={() => props.history.push('/portal/portfolio')}>
                        <HomePageCard className="db-grid-portfolio">
                            <div className="db-grid-boxes-info">
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <h3 style={{ marginBottom: 0 }}>
                                        {en.dashboard.dashboardHome.quicklinks.box1.heading}{' '}
                                        <span>
                                            {' '}
                                            {en.dashboard.dashboardHome.quicklinks.box1.headingBold}
                                        </span>{' '}
                                    </h3>
                                    <Info onClick={modalShow} info={'Portfolios'} />
                                </div>
                                <p> {en.dashboard.dashboardHome.quicklinks.box1.info}</p>
                                <img src="/images/view-portfolio.svg" alt="icon" />
                            </div>
                        </HomePageCard>
                    </a>
                </Grid>
                {ftTransactionFlag === IsAllow.YES ? (
                    <Grid item xs={12} sm={4}>
                        <a onClick={() => props.history.push('/portal/commercial/actions')}>
                            <HomePageCard className="db-grid-track">
                                <div className="db-grid-boxes-info">
                                    <h3 style={{ display: 'inline-flex', alignItems: 'center' }}>
                                        <span>
                                            {en.dashboard.dashboardHome.quicklinks.box4.heading}
                                        </span>{' '}
                                        <img
                                            className="new-icon-box"
                                            style={{ marginLeft: 10 }}
                                            src="/images/new_icon.svg"
                                            alt="icon"
                                        />
                                    </h3>
                                    <p>{en.dashboard.dashboardHome.quicklinks.box4.info}</p>
                                    <img src="/images/track-status.svg" alt="icon" />
                                </div>
                            </HomePageCard>
                        </a>
                    </Grid>
                ) : (
                    <Grid item xs={12} sm={4}>
                        <a onClick={() => props.history.push('/portal/track')}>
                            <HomePageCard className="db-grid-track">
                                <div className="db-grid-boxes-info">
                                    <h3>
                                        {en.dashboard.dashboardHome.quicklinks.box3.heading}{' '}
                                        <span>
                                            {' '}
                                            {en.dashboard.dashboardHome.quicklinks.box3.headingBold}
                                        </span>{' '}
                                    </h3>
                                    <p>{en.dashboard.dashboardHome.quicklinks.box3.info}</p>
                                    <img src="/images/track-status.svg" alt="icon" />
                                </div>
                            </HomePageCard>
                        </a>
                    </Grid>
                )}
                <Grid item xs={12} sm={4}>
                    <a onClick={() => setShow(true)}>
                        <HomePageCard className="db-grid-nct">
                            <div className="db-grid-boxes-info">
                                <h3>
                                    {en.dashboard.dashboardHome.quicklinks.box2.heading}{' '}
                                    <span>
                                        {' '}
                                        {en.dashboard.dashboardHome.quicklinks.box2.headingBold}
                                    </span>
                                </h3>
                                <p>{en.dashboard.dashboardHome.quicklinks.box2.info}</p>
                                <img src="/images/make-nct.svg" alt="icon" />
                            </div>
                        </HomePageCard>
                    </a>
                </Grid>
            </Grid>
            <div className="db-home-sliders db-cards">
                <div className="db-home-slider">
                    <img src="/images/db-home-slider1.png" alt="icon" />
                    <div className="db-home-slider-info">
                        <h5>
                            <a
                            // target="_blank"
                            // href="https://www.etmoney.com/blog/how-to-choose-mutual-funds-for-the-short-term/"
                            >
                                {en.dashboard.dashboardHome.slider.slider1.text}
                            </a>
                        </h5>
                        {/* <p>
                            <img src="/images/time.svg" alt="icon" />1 June, 2021
                        </p> */}
                    </div>
                </div>
            </div>
            <Dialog maxWidth={'sm'} open={show} aria-labelledby="note-modals">
                <div className="note-modals">
                    <h3>{dashboard.noteModals.nctModal.heading}</h3>
                    <p>{dashboard.noteModals.nctModal.info}</p>
                    <div className="note-modals-btns">
                        <Button
                            className="customBtn"
                            onClick={() => props.history.push('/portal/nct')}
                        >
                            {dashboard.noteModals.nctModal.proceedText}
                        </Button>
                        <Button className="customBtn cancelBtn" onClick={() => setShow(!show)}>
                            {dashboard.noteModals.nctModal.cancelText}
                        </Button>
                    </div>
                </div>
            </Dialog>
            <Dialog maxWidth={'md'} open={showAmcModal} aria-labelledby="note-modals">
                <div style={{ maxWidth: 530 }} className="note-modals">
                    <h3>{dashboard.noteModals.nctModal.heading}</h3>
                    <div
                        className="message-popup"
                        style={{ textAlign: 'center' }}
                        dangerouslySetInnerHTML={{
                            __html: shouldParseMessageAsHTML
                                ? props.message
                                : `<p style={{ marginBottom: 15 }}>${props.message}</p>`,
                        }}
                    ></div>
                    <div className="note-modals-btns">
                        <Button
                            className="customBtn"
                            onClick={() => {
                                setShowAmcModal(false);
                                dispatch({ type: CLEAR_POPUP_STATUS });
                            }}
                        >
                            Ok
                        </Button>
                    </div>
                </div>
            </Dialog>
            <FundInfoDialog fundInfoShow={fundInfoShow} setFundInfoShow={setFundInfoShow} />
        </div>
    );
}

export default connect(({ authReducer }: CombinedState<RootStateType>) => ({ ...authReducer }), {
    getPortfolio,
    getNotifications,
})(Home);
